import script from "./AwardsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AwardsList.vue?vue&type=script&setup=true&lang=js"

import "./AwardsList.vue?vue&type=style&index=0&id=c3f84030&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3f84030"]])

export default __exports__